import { useTranslation } from "@next-platform/client-common-core";
import { Modal, ModalSize, useMedia } from "@next-platform/client-common-spicy-ui";
import { JSX } from "react";

import { ChatModalVoiceSelectionProps } from "./types";
import { VoiceSelectionContent } from "./VoiceSelectionContent";

export function ChatModalVoiceSelection({
  trigger,
  onOpenChange,
  open,
  loading,
  stopAudio,
  description,
  listItems,
  defaultSelectedVoice,
  loadingList,
  voiceSelectionLoading,
  onVoiceSelection,
  onSearch,
  voiceCategoryList,
  selectedCategory,
  onPressCategory,
  characterDefaultVoiceId,
  dataTestId = "",
}: ChatModalVoiceSelectionProps): JSX.Element {
  const { t } = useTranslation();
  const { isMobile } = useMedia();
  return (
    <Modal
      className="h-full"
      size={isMobile ? ModalSize.FULLSCREEN : ModalSize.LARGE}
      classNames={{ content: "overflow-y-hidden overflow-x-hidden !px-0" }}
      open={open}
      title={t("chat:modal.voiceSelection.title")}
      description={description}
      loading={loading}
      trigger={trigger}
      onOpenChange={onOpenChange}
    >
      <VoiceSelectionContent
        dataTestId={dataTestId}
        listItems={listItems}
        loadingList={loadingList}
        defaultSelectedVoice={defaultSelectedVoice}
        voiceSelectionLoading={voiceSelectionLoading}
        onVoiceSelection={onVoiceSelection}
        onSearch={onSearch}
        stopAudio={stopAudio}
        isMobile={isMobile}
        voiceCategoryList={voiceCategoryList}
        selectedCategory={selectedCategory}
        onPressCategory={onPressCategory}
        characterDefaultVoiceId={characterDefaultVoiceId}
      />
    </Modal>
  );
}
